<script>
  export let full = ''
  export let small = ''
  export let height = 100
  export let brightness = '0.7'
  export let grayscale = '10%'
  export let shadow = false
  export let zoom = false

  let loaded = false
</script>


<div class="box" style="height: {height}">
  <div class="relative w-full overflow-hidden" style="height: {height}; z-index: -1">
    <div class="absolute top-0 left-0 w-full h-full"
         style={shadow ? 'background: linear-gradient(to right, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));' : ''}>&nbsp;
    </div>

    <img class="placeholder" src={small} alt="small"
         style="height: {height}; filter: brightness({brightness}) grayscale({grayscale}) blur(15px);" />

    <img
      class="bg {zoom ? 'zoom': ''}"
      class:animate={loaded === true}
      src={full}
      alt="backgroundimage"
      style="height: {height}; filter: brightness({brightness}) grayscale({grayscale})"
      on:load={() => (loaded = true)}
    />
  </div>
</div>


<style>
    .box {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        z-index: -1;
    }

    .bg,
    .placeholder {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        object-fit: cover;
        z-index: -1;
        transform: scale(1.05);
    }

    .bg {
        transition: opacity 0.3s;
        filter: blur(10px);
        opacity: 0.1;
        clip: rect(auto auto auto auto);
    }

    .placeholder {
        filter: blur(15px);
        clip: rect(auto auto auto auto);
    }

    .animate {
        opacity: 1;
        filter: blur(0);
    }

    .zoom {
        transform-origin: center center;
        animation: scale 60s linear infinite;
        animation-direction: alternate;
    }

    @keyframes scale {
        to {
            transform: scale(1.3);
        }
    }
</style>

